// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3ltdV","title":"ClientInsurance_title__11O1n","itemText":"ClientInsurance_itemText__2HDGg"};